import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/Stats.css";
import { FaPlay, FaServer, FaClipboard, FaTrophy, FaCalendarAlt } from "react-icons/fa"; // Including icons for stats

const Stats = () => {
  const [minecraftStatus, setMinecraftStatus] = useState({
    status: "Checking...",
    playersOnline: 0,
    maxPlayers: 0,
  });

  const [lastVote, setLastVote] = useState(null);
  const [topVoter, setTopVoter] = useState(null);
  const [loading, setLoading] = useState(true);

  // Minecraft-MP API credentials
  const apiKey = "P8SXF1NRJnb7cVhuGby4BrzvFyKohhZP9Z"; // Your Minecraft-MP API Key
  const serverId = "338489"; // Your Minecraft Server ID

  useEffect(() => {
    // Fetch Minecraft server status from mcsrvstat.us
    axios
      .get("https://api.mcsrvstat.us/2/play.rixxymc.fun:25565")
      .then((response) => {
        const data = response.data;
        setLoading(false);
        if (data.online) {
          setMinecraftStatus({
            status: "Online",
            playersOnline: data.players.online,
            maxPlayers: data.players.max,
          });
        } else {
          setMinecraftStatus({
            status: "Offline",
            playersOnline: 0,
            maxPlayers: 0,
          });
        }
      })
      .catch(() => {
        setLoading(false);
        setMinecraftStatus({
          status: "Error fetching status",
          playersOnline: 0,
          maxPlayers: 0,
        });
      });

    // Fetch Top Voter from Minecraft-MP API
    axios
      .get(`https://minecraft-mp.com/api/server/${serverId}/top_voters/?key=${apiKey}`)
      .then((response) => {
        if (response.data && response.data[0]) {
          setTopVoter(response.data[0]); // Assuming response is an array
        }
      })
      .catch(() => setTopVoter(null));

    // Fetch Last Vote from Minecraft-MP API
    axios
      .get(`https://minecraft-mp.com/api/server/${serverId}/votes/?key=${apiKey}`)
      .then((response) => {
        if (response.data && response.data[0]) {
          setLastVote(response.data[0]); // Adjust based on actual API response structure
        }
      })
      .catch(() => setLastVote(null));
  }, []);

  const copyIP = () => {
    const serverIP = "play.rixxymc.fun:25565";
    navigator.clipboard.writeText(serverIP).then(() => {
      alert("IP copied to clipboard!");
    });
  };

  return (
    <div className="status-page">
      <div className="status-header">
        <h1>
          <span className="highlight">RixxyMC</span> Stats
        </h1>
        <p className="tagline">
          Your gateway to an unforgettable <span className="highlight">adventure</span>!
        </p>
      </div>

      <div className="status-container">
        {/* Introduction Card */}
        <div className="card animated introduction">
          <FaPlay className="icon" />
          <h2>✨ Join the Fun!</h2>
          <p>
            <strong>Minecraft</strong> server for Java and Bedrock players.
            Unleash your creativity, build, and explore with a vibrant community!
          </p>
          <div className="join-details">
            <p>
              <strong>Java:</strong> <span className="highlight">play.rixxymc.fun</span>:25565
            </p>
            <p>
              <strong>Bedrock:</strong> <span className="highlight">play.rixxymc.fun</span>:25565
            </p>
          </div>
        </div>

        {/* Server Stats Card */}
        <div className="card animated stats-info">
          <FaServer className="icon" />
          <h2>🛠️ Server Stats</h2>
          <div className="stats-details">
            {loading ? (
              <div className="loading-spinner">🔄 Loading...</div>
            ) : (
              <>
                <p>
                  Status: <span className={minecraftStatus.status.toLowerCase()}>{minecraftStatus.status}</span>
                </p>
                {minecraftStatus.status === "Online" && (
                  <>
                    <p>
                      Players: <span className="highlight">{minecraftStatus.playersOnline}</span> /{" "}
                      <span className="highlight">{minecraftStatus.maxPlayers}</span>
                    </p>
                    <button className="btn copy-ip-btn" onClick={copyIP}>
                      <FaClipboard /> Copy IP
                    </button>
                  </>
                )}
              </>
            )}
          </div>
        </div>

        {/* Vote Stats Cards */}
        <div className="card animated vote-stats">
          <FaTrophy className="icon" />
          <h2>🏆 Top Voter</h2>
          {topVoter ? (
            <p>
              <strong>Player:</strong> {topVoter.player} <br />
              <strong>Votes:</strong> {topVoter.votes}
            </p>
          ) : (
            <p>Loading top voter...</p>
          )}
        </div>

        <div className="card animated vote-stats">
          <FaCalendarAlt className="icon" />
          <h2>🕒 Last Vote</h2>
          {lastVote ? (
            <p>
              <strong>Player:</strong> {lastVote.player} <br />
              <strong>Time:</strong> {lastVote.time}
            </p>
          ) : (
            <p>Loading last vote...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Stats;
